<template>
  <div class="tickets section container">
    <h3>{{ $t('tickets.1seleccionaElTipoDeEntrada') }}</h3>
    <b-form @submit.prevent="manageTickets">
      <b-row class="no-gutters">
        <b-col cols="12"
               md="6">
          <div v-for="(ticket, index) in ticket_types"
               :key="index"
               class="ticket">
            <div class="top-info">
              <div class="container-title">
                <p class="title">{{ ticket.title }}</p>
                <p v-if="ticket.description"
                   :class="{'description-open': ticket.id === ticket_open}"
                   class="description">{{ ticket.description }}</p>
                <p v-if="ticket.description"
                   class="ver-mas"
                   @click="seeMore(ticket.id)">{{ $t('tickets.verMas') }}</p>
              </div>
              <div class="container-price">
                <span v-if="ticket.currency"
                      class="price">{{ $n(ticket.price, { key: 'currency', currency: ticket.currency }) }}</span>
                <div v-if="ticket.available > 0"
                     class="container-selector-tickets">
                  <b-button class="round minus transparent"
                            @click="minusQuantity(ticket, index)">-</b-button>
                  <span class="quantity">{{ quantities[index] }}</span>
                  <b-button class="round more transparent"
                            @click="moreQuantity(ticket, index)">+</b-button>
                </div>
                <div v-else-if="ticket.available === 0 && ticket.reserved"
                     class="reserved">
                  <span class="reserved-text"> {{ $t('tickets.reserved') }} </span>
                  <div id="reserved-info"
                       class="reserved-info"></div>
                  <b-tooltip :target="`reserved-info${index}`"
                             triggers="hover">
                    {{ $t('tickets.enEsteMomentoTodosLasEntradasEstanReservadas') }}
                  </b-tooltip>
                </div>
                <div v-else-if="ticket.available === 0 && !ticket.reserved"
                     class="sold-out">
                  <span class="sold-out-text"> {{ $t('tickets.soldOut') }} </span>
                  <div id="sold-out-info"
                       class="sold-out-info"></div>
                  <b-tooltip :target="`sold-out-info${index}`"
                             triggers="hover">
                    {{ $t('tickets.lasEntradasDeEsteTipoEstanAgotadas') }}
                  </b-tooltip>
                </div>
              </div>
            </div>
            <p v-if="ticket.show_remaining && ticket.available"
               class="remaining-tickets"
               :class="{'remaining-tickets-warning': ticket.remaining < 25}"> {{ $t('tickets.remaining', {remaining: ticket.remaining}) }}</p>
          </div>
          <div v-if="event.authorization_file_url || event.access_policy"
               class="mB20">
            <div v-if="event.authorization_file_url"
                 cols="12">
              <a :href="event.authorization_file_url"
                 :title="event.authorization_file_url"
                 target="_blank">
                <p class="help-text m0">{{ $t('tickets.descargarAutorizacionParaMenores') }}</p>
              </a>
            </div>
            <div v-if="event.access_policy"
                 cols="12">
              <text-truncate :color="event.iframe ? event.iframe.aux_font_color || event.iframe.font_color: ''">
                <p :style="`color: ${event.iframe ? event.iframe.aux_font_color || event.iframe.font_color: ''}`">{{ event.access_policy }}</p>
              </text-truncate>
            </div>
          </div>
        </b-col>
        <b-col cols="12"
               md="6"
               class="container-purchase-detail">
          <div id="purchaseDetail"
               class="selected">
            <div v-if="selected.length === 0"
                 class="w100">
              <p v-if="selected.length === 0"
                 class="nothing"> {{ $t('tickets.todaviaNoTienesEntradasSeleccionadas') }} </p>
              <p v-if="selected.length === 0"
                 class="help-text"> {{ $t('tickets.seleccionaAlgunaEntrada') }} </p>
            </div>
            <div v-else
                 class="w100">
              <p class="detail">{{ $t('tickets.detalleDeCompra') }}</p>
              <div class="container-info">
                <div v-for="ticket in selected"
                     :key="ticket.id">
                  <p class="tAl info">{{ ticket.quantity }}x {{ ticket.title }}</p>
                  <p class="tAr info">{{ $n(ticket.price * ticket.quantity, { key: 'currency', currency: ticket.currency }) }}</p>
                </div>
                <p class="tAl info">{{ $t('tickets.gastosDeGestion') }}</p>
                <p class="tAr info">{{ $n(taxes, { key: 'currency', currency: currency }) }}</p>
                <p class="tAl total">{{ $t('tickets.total') }}</p>
                <p class="tAr total">{{ $n(total, { key: 'currency', currency: currency }) }}</p>
              </div>
            </div>
            <b-form-group v-if="event.promoter_newsletter_option && !isDisabled"
                          id="purchase-newsletter-group"
                          class="mT10 tAl mW90Per w100">
              <b-form-checkbox id="purchase-newsletter"
                               v-model="promoter_newsletter">
                <span :style="`color: ${event.iframe ? event.iframe.aux_font_color || event.iframe.font_color : ''}`">{{ $t('tickets.newsletter', {promoter_newsletter_text: event.promoter_newsletter_text}) }}</span>
              </b-form-checkbox>
            </b-form-group>
            <b-form-group v-if="event.promoter_terms_option && !isDisabled"
                          id="purchase-terms-group"
                          class="mT10 tAl mW90Per w100">
              <b-form-checkbox id="purchase-terms"
                               v-model="purchase.promoter_terms">
                <span :style="`color: ${event.iframe ? event.iframe.aux_font_color || event.iframe.font_color : ''}`"
                      v-html="$t('tickets.promoter_terms', {promoter_terms_text: event.promoter_terms_text})" />
              </b-form-checkbox>
            </b-form-group>
            <b-button v-if="!event.promoter_terms_option || (event.promoter_terms_option && promoter_terms)"
                      :disabled="isDisabled"
                      type="submit"
                      :class="{'opacity': !isDisabled, 'transparent': isDisabled}"
                      class="purchase">{{ $t('tickets.siguiente') }}</b-button>
            <b-button v-else
                      :disabled="isDisabled"
                      :class="{'opacity': !isDisabled, 'transparent': isDisabled}"
                      class="purchase"
                      @click="modalTerms($t('tickets.promoter_terms_modal'))">{{ $t('tickets.siguiente') }}</b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
    <nominatives v-if="openNominatives" />
    <loader v-show="loading"
            class="load-more-loader"
            :middle="true" />
  </div>
</template>

<script>
import { purchase } from '@/plugins/mixins/purchase.js'
import { userStatus } from '@/plugins/mixins/userStatus.js'
import TextTruncate from '@/components/text-truncate/TextTruncate.vue'
import Nominatives from '@/components/nominatives/Nominatives.vue'
import Loader from '@/components/loader/Loader.vue'

export default {
  components: {
    Nominatives,
    TextTruncate,
    Loader
  },
  mixins: [purchase, userStatus],
  props: {
    modal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      quantities: [],
      openNominatives: false,
      timeout: undefined,
      header: undefined,
      purchaseDetail: undefined,
      loading: true,
      ticket_open: false
    }
  },
  computed: {
    isDisabled() {
      return this.$store.state.tickets.selected.length === 0
    },
    selected() {
      return this.$store.state.tickets.selected
    },
    total() {
      return this.$store.state.tickets.total
    },
    taxes() {
      return this.$store.state.tickets.taxes
    },
    currency() {
      return this.$store.state.tickets.currency
    },
    ticket_types() {
      return this.$store.state.tickets.ticketTypes
    },
    event() {
      return this.$store.state.event.detail
    },
    purchase() {
      return this.$store.state.purchase
    },
    promoter_terms: {
      get() {
        return this.$store.state.purchase.promoter_terms
      },
      set(value) {
        this.$store.dispatch('purchase/setPromoterTerms', value)
      }
    },
    promoter_newsletter: {
      get() {
        return this.$store.state.purchase.promoter_newsletter
      },
      set(value) {
        this.$store.dispatch('purchase/setPromoterNewsletter', value)
      }
    }
  },
  created() {
    this.quantities = new Array(
      this.$store.state.event.detail.ticket_types_count > 49 ?
        this.$store.state.event.detail.ticket_types_count : 49
    )
      .fill(0)

    this.$root.$on('closeNominatives', () => {
      this.openNominatives = false
    })
    this.$store.dispatch('tickets/cleanSelected')
    this.$root.$on('purchaseLoading', status => {
      this.loading = status
    })
  },
  async mounted() {
    await this._getTicketTypes()
    this._checkTicketTypes()
    this.header = document.getElementById('header')
    this.purchaseDetail = document.getElementById('purchaseDetail')
    window.addEventListener('scroll', this.handleScrollPurchaseDetail)
    this.handleScrollPurchaseDetail()
    this.loading = false
  },
  destroyed() {
    clearTimeout(this.timeout)
    this.timeout = null
    window.removeEventListener('scroll', this.handleScrollPurchaseDetail)
    this.header = undefined
    this.purchaseDetail = undefined
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    modalTerms(text) {
      if (typeof CustomEvent === 'function') {
        var event = new CustomEvent('showError', {
          detail: {
            text: text,
            type: 'info'
          }
        })
        window.dispatchEvent(event)
      }
    },
    handleScrollPurchaseDetail() {
      var deviceType = this.isMobile()
      if (
        this.header &&
        deviceType === 'pc' &&
        this.purchaseDetail &&
        window.scrollY >
          this.purchaseDetail.parentNode.offsetTop -
            this.header.offsetHeight -
            20
      ) {
        this.purchaseDetail.classList.add('isAffixed')
        if (
          document.getElementById('container-download-app') &&
          this.purchaseDetail.offsetHeight +
            this.purchaseDetail.offsetTop +
            30 +
            window.scrollY >=
            document.getElementById('container-download-app').offsetTop
        ) {
          this.purchaseDetail.classList.add('touchFooter')
          this.purchaseDetail.style.bottom =
            document.getElementsByTagName('footer')[0].offsetHeight +
            document.getElementById('container-download-app').offsetHeight +
            30 +
            'px'
        } else {
          this.purchaseDetail.style.bottom = 'inherit'
          this.purchaseDetail.classList.remove('touchFooter')
        }
      } else if (this.purchaseDetail && this.purchaseDetail.classList) {
        this.purchaseDetail.classList.remove('isAffixed')
        this.purchaseDetail.classList.remove('touchFooter')
      }
    },
    ticketOptions(available) {
      return Array.from(Array(available + 1), (x, index) => index)
    },
    minusQuantity(ticket, index) {
      if (this.$store.state.tickets.currency === '')
        this.$store.dispatch('tickets/setCurrency', ticket.currency)
      if (
        this.quantities[index] - 1 >= 0 &&
        this.$store.state.tickets.currency === ticket.currency
      )
        this.quantities[index] = this.quantities[index] - 1
      else if (this.$store.state.tickets.currency !== ticket.currency) {
        this.quantities[index] = 0
        this._showErrorCurrencies()
      }
      this.changeQuantity(ticket, this.quantities[index])
      this.$forceUpdate()
    },
    moreQuantity(ticket, index) {
      if (this.$store.state.tickets.currency === '') {
        this.$store.dispatch('tickets/setCurrency', ticket.currency)
      }
      if (
        this.quantities[index] + 1 <= ticket.available &&
        this.$store.state.tickets.currency === ticket.currency
      ) {
        this.quantities[index] = this.quantities[index] + 1
      } else if (this.$store.state.tickets.currency !== ticket.currency) {
        this._showErrorCurrencies()
      }
      this.changeQuantity(ticket, this.quantities[index])
      this.$forceUpdate()
    },
    changeQuantity(ticket, quantity) {
      this.$store.dispatch('tickets/add', {
        ticket: ticket,
        quantity: quantity
      })
      this.$store.dispatch('tickets/setTaxesAndTotal')
      if (this.$store.state.tickets.selected.length === 0)
        this.$store.dispatch('tickets/setCurrency', '')
    },
    manageTickets() {
      if (
        this.$store.state.event.detail.promoter_terms_option &&
        !this.promoter_terms
      ) {
      } else {
        this.loading = true
        var tickets = []
        this.$store.state.tickets.selected.forEach((item, index) => {
          tickets = tickets.concat(
            Array.from(Array(parseInt(item.quantity)), () => {
              return { ticket_type: item.id }
            })
          )
        })
        this.$store.dispatch('purchase/setTickets', { tickets: tickets })
        if (this._nominatives()) {
          this.loading = false
          this.openNominatives = true
        } else {
          if (
            this.$store.state.initial.detail.user_id ||
            this.$store.state.user.detail.id
          ) {
            this.checkUserStatus().then(res => {
              if (res === 'name' || res === 'profile') {
                this.loading = false
                this.$root.$emit('openBasicInfoPurchase')
              } else
                this.createPurchase().catch(response => {
                  this.$root.$emit('purchaseLoading', false)
                  if (response.status === 409) {
                    this.$store.dispatch('tickets/cleanSelected')
                    this.$store.dispatch('purchase/cleanTickets')
                    this._checkTicketTypes()
                  } else {
                    if (typeof CustomEvent === 'function') {
                      var event = new CustomEvent('showError', {
                        detail: {
                          textI18N: 'error.title',
                          error: response
                        }
                      })
                      window.dispatchEvent(event)
                    }
                  }
                })
            })
          } else {
            this.loading = false
            if (process.env.VUE_APP_BUYER === 'false') {
              this.$root.$emit('openSignupPurchase')
            } else {
              this.$root.$emit('openBuyerInfo')
            }
          }
        }
      }
    },
    seeMore(id) {
      if (this.ticket_open === id) {
        this.ticket_open = undefined
      } else {
        this.ticket_open = id
      }
    },
    async _checkTicketTypes() {
      if (
        this.$store.state.tickets.ticketTypes.length > 0 &&
        this.$store.state.tickets.ticketTypes.some(item => {
          return item.reserved && item.available === 0
        })
      ) {
        this.$store.dispatch('tickets/cleanList')
        const promises = []
        const page_size = 50
        const lastPage =
          parseInt(
            this.$store.state.event.detail.ticket_types_count / page_size
          ) + 1
        for (let index = 1; index <= lastPage; index++) {
          let payload = {
            event: this.$store.state.event.detail.id,
            page: index,
            page_size: page_size
          }
          promises.push(this.$store.dispatch('tickets/filter', payload))
        }
        await Promise.all(promises)
        this.timeout = setTimeout(() => {
          this._checkTicketTypes()
        }, 30000)
      } else {
        clearTimeout(this.timeout)
        this.timeout = null
      }
    },
    async _getTicketTypes() {
      const promises = []
      if (
        this.$store.state.event.detail.enabled &&
        !this.$store.state.event.detail.closed &&
        this.$store.state.event.detail.tickets_enabled &&
        this.$store.state.event.detail.ticket_types_count > 0 &&
        this.$store.state.event.detail.ticket_distributions.length === 0
      ) {
        const page_size = 50
        const lastPage = Math.ceil(
          this.$store.state.event.detail.ticket_types_count / page_size
        )
        for (let index = 1; index <= lastPage; index++) {
          let payload = {
            event: this.$store.state.event.detail.id,
            page: index,
            page_size: page_size
          }
          promises.push(this.$store.dispatch('tickets/filter', payload))
        }
      }
      await Promise.all(promises)
    },
    _nominatives() {
      return this.$store.state.tickets.selected.some(
        item => item.personal || item.personal_id
      )
    },
    _showErrorCurrencies() {
      var customEvent = new CustomEvent('showError', {
        detail: {
          text: 'No puedes seleccionar entradas con distintas monedas'
        }
      })
      window.dispatchEvent(customEvent)
    }
  }
}
</script>
<style lang="scss">
@import './ticket.sass';
</style>
